var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.299,
    height: 5.281,
    viewBox: "0 0 9.299 5.281",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "caret-up",
    d: "M9.031-3H.969a.564.564,0,0,1-.562-.391.575.575,0,0,1,.125-.672L4.563-8.094A.6.6,0,0,1,5-8.281a.6.6,0,0,1,.438.188L9.469-4.062a.575.575,0,0,1,.125.672A.564.564,0,0,1,9.031-3Z",
    transform: "translate(-0.35 8.281)",
    fill: "#5d6373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretUp);
export default __webpack_public_path__ + "static/media/caret-up.76b71e60545f5360a09fe3235557abd8.svg";
export { ForwardRef as ReactComponent };